import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import "./newAppointment.css";

const WEEKDAY_LABELS = ["Pon", "Uto", "Sre", "Čet", "Pet", "Sub", "Ned"];

// Pure helper (no component state) — builds one month's day cells, padded with `null` leading
// blanks so the grid lines up under Monday-first weekday labels. Shared by every consumer so the
// blank-cell math only lives in one place.
const buildMonthDays = (viewMonth) => {
  const start = viewMonth.clone().startOf("month");
  const end = viewMonth.clone().endOf("month");
  const startWeekday = (start.day() + 6) % 7;
  const days = [];
  for (let i = 0; i < startWeekday; i++) days.push(null);
  for (let d = 1; d <= end.date(); d++) {
    days.push(start.clone().date(d));
  }
  return days;
};

// Shared month-grid calendar (nav header + weekday labels + day cells) — originally built inline
// for NewAppointmentFlow's date step, extracted here so the Mobile Calendar screen's "jump to
// month" popup (MobileHeader's title tap) reuses the exact same markup/CSS classes
// (newAppointment.css's .hf-naf-*) instead of a second implementation of the same date-picker.
// `isSelectableDay` is optional — omit it (as the Calendar popup does) to make every day
// selectable; NewAppointmentFlow still passes its own predicate to keep excluding past days/Sundays.
const MonthCalendarGrid = ({
  viewMonth,
  onPrevMonth,
  onNextMonth,
  monthDays,
  today,
  selectedDate,
  isSelectableDay,
  onSelectDay,
}) => (
  <>
    <div className="hf-naf-month-nav">
      <button
        type="button"
        onClick={onPrevMonth}
        aria-label="Prethodni mesec"
      >
        <ChevronLeftIcon sx={{ fontSize: 18 }} />
      </button>
      <span>{viewMonth.format("MMMM YYYY")}</span>
      <button
        type="button"
        onClick={onNextMonth}
        aria-label="Sledeći mesec"
      >
        <ChevronRightIcon sx={{ fontSize: 18 }} />
      </button>
    </div>
    <div className="hf-naf-weekday-labels">
      {WEEKDAY_LABELS.map((d) => (
        <span key={d}>{d}</span>
      ))}
    </div>
    <div className="hf-naf-day-grid">
      {monthDays.map((day, index) => {
        if (!day) return <span key={index} />;
        const selectable = isSelectableDay ? isSelectableDay(day) : true;
        const isSelected = selectedDate && day.isSame(selectedDate, "day");
        const isToday = day.isSame(today, "day");
        return (
          <button
            type="button"
            key={index}
            disabled={!selectable}
            className={`hf-naf-day${isSelected ? " selected" : ""}${
              isToday ? " today" : ""
            }`}
            onClick={() => onSelectDay(day)}
          >
            {day.date()}
          </button>
        );
      })}
    </div>
  </>
);

export default MonthCalendarGrid;
export { buildMonthDays, WEEKDAY_LABELS };
